/** @param {Record<string, unknown[]>} prev @param {Record<string, unknown>} opts */
export function appendInitialSendMessages(prev, opts) {
  const { tid, priorMessages, userMsg, pendingAssistant } = opts
  return { ...prev, [tid]: [...priorMessages, userMsg, pendingAssistant] }
}
